import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M15.009 6.435a.75.75 0 0 0 .275.236l5.226 4.479a.76.76 0 0 0 .49.18.75.75 0 0 0 .47-1.32l-.97-.831V3.75a1.5 1.5 0 0 0-1.5-1.5h-2.63a1.5 1.5 0 0 0-1.5 1.5v.603l-1.1-.943a2.73 2.73 0 0 0-3.58 0l-7.7 6.6a.758.758 0 1 0 1 1.14l.05-.043v8.143H3a.75.75 0 1 0 0 1.5h9a.75.75 0 1 0 0-1.5H9.75V15a.25.25 0 0 1 .25-.25h2a.75.75 0 1 0 0-1.5h-2A1.75 1.75 0 0 0 8.25 15v4.25H5.04V9.822l6.15-5.272a1.24 1.24 0 0 1 1.62 0zM19 7.893V3.75h-2.63v1.889z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M17.039 21.555c.304.129.63.195.961.195v-.01a2.5 2.5 0 0 0 1.77-.74l2.12-2.14a3 3 0 0 0 0-4.23 3 3 0 0 0-3.89-.27 3 3 0 0 0-3.89 4.49L16.23 21c.23.237.505.426.809.555M15.21 15.68a1.44 1.44 0 0 1 1-.43 1.44 1.44 0 0 1 1.03.48l.22.23a.76.76 0 0 0 .54.23.72.72 0 0 0 .53-.23l.23-.23a1.47 1.47 0 0 1 2.06 0 1.54 1.54 0 0 1 0 2.13L18.7 20a1 1 0 0 1-.7.3 1 1 0 0 1-.7-.3l-2.09-2.19a1.54 1.54 0 0 1 0-2.13",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }